import {publicApi} from '@hconnect/adminconsole/src/App.store'
import {useQuery} from '@tanstack/react-query'

import {PermissionType} from '../RequestAccessSelfOnboarding.types'

const optionsFetcher = async (countryId?: string) => {
  if (!countryId) {
    return null
  }

  const result = await publicApi.get<string[]>(`/options?countryId=${countryId}`)
  return result.data
}

export const useAvailablePermissions = (countryId?: string) => {
  const result = useQuery(['options', {countryId}], () => optionsFetcher(countryId), {
    enabled: !!countryId
  })

  const formattedPermissions: PermissionType | null = result.data
    ? Object.fromEntries(
        result.data.map((permission) => [permission, permission === 'canSeeOrderAndDeliveries'])
      )
    : null

  return {
    availablePermissions: formattedPermissions,
    isLoading: result.isLoading,
    isError: result.isError
  }
}
